<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YwjHFO/tc-custom/9781426858062.jpg?1708088026337" alt="This image is the cover for the book Wedding Vow of Revenge, Royal Brides"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wedding Vow of Revenge, Royal Brides
      </h1>
      <p class="bookDescription body article font2">
        <b>“A hypnotic tale of love and vengeance” from the <i>USA Today</i>–bestselling author of <i>The Sheikh’s Bartered Bride </i>(<i>CataRomance Reviews</i>).</b><br/><br/>The instant Angelo Gordon sees model Tara Peters he’s certain she will share his bed. But her beauty isn’t the only attraction—he wants payback!<br/><br/>Tara is not an easy conquest. When she pushes Angelo away he realizes he can only win her over by playing a different game. Angelo will raise the stakes and take the ultimate revenge: marriage!<br/><br/><b>“Lucy Monroe delivers another exciting Presents guaranteed to wow readers. Sensual and emotional, <i>Wedding Vow of Revenge</i> is a nicely written and well-crafted story about two strong but lonely people struggling to overcome the darkness in their pasts. In doing so, they find each other and their future.” —<i>The Romance Reader Connection</i> (4 stars)</b><br/><br/><b>“Lucy Monroe has once again taken her readers on a journey of tenderness by creating exceptionally likeable characters that sizzle. Be prepared to put the time aside you need to read this book.” —</b><a href="http://www.aromancereview.com/reviews/index.php?app_state=show_event&amp;bookid=8000" target="_blank"><b><i>A Romance Review</i></b></a><b> (5 stars)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucy  Monroe
      </h2>
      
      <p class="authorDescription body article">USA Today Bestseller Lucy Monroe finds inspiration for her stories everywhere as she is an avid people-watcher. She has published more than fifty books in several subgenres of romance and when she&#39;s not writing, Lucy likes to read. &#160;She&#39;s an unashamed book geek, but loves movies and the theatre too. She adores her family and truly enjoys hearing from her readers! Visit her website at: http://lucymonroe.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35e1a463